"use client";
import ProcessBar from "@/app/components/pages/cart/ProcessBar";
import { useEffect, useState } from "react";
import CartProcessStep from "@/app/constants/CartProcessStep";
import CartContent from "@/app/components/pages/cart/CartContent";
import DeliveryDetails from "@/app/components/pages/cart/DeliveryDetails";
import SenderDetails from "@/app/components/pages/cart/SenderDetails";
import PaymentDetails from "@/app/components/pages/cart/PaymentDetails";
import { getWCProducts } from "@/app/services/ProductService";
import { useCartHook } from "@/app/hooks/useCartHook";
import styles from "@/app/styles/components/pages/cart/cart-wrapper.module.scss";


const CartWrapper = ({ data }) => {

    const [step, setStep] = useState(CartProcessStep.CART)
    const [products, setProducts] = useState([])
    const [agreed, setAgreed] = useState(false);

    const handleRemoveItem = (id) => {
        setProducts((prevProducts) => prevProducts.filter(product => product.id !== id));
    }
    const getProducts = async (ids) => {
        if (ids.length) {
            return await getWCProducts({
                include: ids.join(',')
            })
        }
        return []
    }
    const { cart } = useCartHook({ cookieData: data.cookieCart })
    useEffect(() => {
        const ids = Object.keys(cart)
        if (ids.length) {
            getProducts(ids).then(products => {
                setProducts(products.data)
            })
        }

    }, [cart])
    const changeStep = (step) => {
        setStep(step);
    };
    return <>
        <ProcessBar step={step} changeStep={changeStep} />

        <div className={styles.cartWrapperContainer}>            {
            step === CartProcessStep.CART &&
            <CartContent data={data} products={products} cart={cart} changeStep={changeStep} onRemoveItem={handleRemoveItem} />
        }
            {
                step === CartProcessStep.DELIVERY &&
                <DeliveryDetails data={data} products={products} cart={cart} changeStep={changeStep} agreed={agreed} setAgreed={setAgreed} />
            }
            {
                step === CartProcessStep.SENDER &&
                <SenderDetails data={data} products={products} cart={cart} changeStep={changeStep} agreed={agreed} setAgreed={setAgreed} />
            }
            {
                step === CartProcessStep.PAYMENT &&
                <PaymentDetails data={data} cart={cart} changeStep={changeStep} />
            }

        </div>

    </>
};

export default CartWrapper;
